import superFetch from "../../../utils/superFetch"; //(endpoint, method, data, token)

export const verifyOtpForNewUsers = async (data) => {
    let response = await superFetch("/api/send/otp/verify", "post", data)
    return response
}

export const verifyOtpForMobile = async (data) => { //mobileNumber, otp
    let response = await superFetch("/api/send/verify/mobile", "post", data)
    return response
}

export const verifyOtpForEmail = async (data) => { //email, otp
    let response = await superFetch("/api/send/verify/email", "post", data)
    return response
}